import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './AdminContainer.module.css';

const SuperAdminContainer = ({ type, children }) => {
    if(type!= 'Admin') {
        return (
            <div className={styles['restricted']}>Restricted area !</div>
        )
    }
    return (
        <>{children}</>
    );
};

SuperAdminContainer.propTypes = {
    type: PropTypes.string,
    children: PropTypes.node
};

const mapStateToProps = state => ({
    type: state.auth && state.auth.user ? state.auth.user.type : null
});

export default connect(mapStateToProps, {})(SuperAdminContainer);
